import React from 'react';
import { ButtonToolbar, Panel, Button, Icon } from 'rsuite';
import * as PERMISSIONS from '../../../constants/permissions/storage';
import { viewAccess, modifyAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import StoragePageLayout from '../../../components/storage/PageLayout';
import PageHeader from '../../../components/PageHeader';
import { storageCreatePath } from '../../Paths';
import Link from '../../../components/Link';
import StorageDeviceList from '../../../components/storage/List';

export default () => (
  <StoragePageLayout>
    <AccessControl
      allowOnlyFor={viewAccess(PERMISSIONS.DEVICE)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Devices">
        <Panel bordered>
          <ButtonToolbar style={{ float: 'right' }}>
            <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.DEVICE)}>
              <Link to={storageCreatePath}>
                <Button appearance="primary">
                  <Icon icon="plus-circle" /> Create New
                </Button>
              </Link>
            </AccessControl>
          </ButtonToolbar>
        </Panel>
      </PageHeader>
      <Panel>
        <StorageDeviceList />
      </Panel>
    </AccessControl>
  </StoragePageLayout>
);
